import { Provider } from '@angular/core';
import { OktaLoginService } from './okta-login.service';

// services
export * from './okta-login.service';

export const OktaServiceProviders: Provider[] = [OktaLoginService];
